// extracted by mini-css-extract-plugin
module.exports = {"product":"Product_product__3Fyz2","spinnerContainer":"Product_spinnerContainer__2-bJX"};